// eslint-disable-next-line import/prefer-default-export
export const SET_VEHICLES_LIST = 'SET_VEHICLES_LIST';
export const SET_VEHICLES_INFO = 'SET_VEHICLES_INFO';
